import React from "react";
import { bool, node, string } from "prop-types";
import { classes } from "../utils/classes";
import pureFC from "../utils/pureFC";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { sizingClassName, sizingProps, sizingPropTypes } from "../props/sizing";

const FormGroup = ({
	isCheckBox = false,
	isRadio = false,
	required,
	error = false,
	className,
	spacing = { ...spacingProps },
	utility = { ...utilityProps },
	sizing = { ...sizingProps },
	...props
}) => (
	<div
		className={classes(
			"field",
			isCheckBox && "field-checkbox",
			isRadio && "field-radio",
			required && "field--required",
			error && "field--error",
			...utilityClassName(utility),
			...spacingClassName(spacing),
			...sizingClassName(sizing),
			className,
		)}
		{...props}
	/>
);

FormGroup.propTypes = {
	isCheckBox: bool,
	isRadio: bool,
	required: bool,
	error: node,
	className: string,
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
	sizing: sizingPropTypes,
};

export default pureFC(FormGroup);
